// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nion-card-subtitle[data-v-c964f584] {\n    line-height: 1.8;\n}\n.dense[data-v-c964f584] {\n    line-height: 1.5;\n}\n.address-display:not(.large) > span[data-v-c964f584] {\n    font-size: 16px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
